import { defineStore } from 'pinia';
import { useMilkomedaWSCUnwrapBridge } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCUnwrapBridge';

export const useSingleSideMilkomedaWSCUnwrapBridge = defineStore(
  'singleSideMilkomedaWSCUnwrapBridge',
  () => {
    const milkomedaWSCUnwrapBridge = useMilkomedaWSCUnwrapBridge();

    return {
      ...milkomedaWSCUnwrapBridge,
    };
  },
);
